import { FieldErrors } from 'react-hook-form';
import { IFormState } from '../types/calculator/form';
import { IFieldElement, IScheme } from '../types/calculator';

/**
 * Тулза для обогащения события ошибок, обогащает событие следующими полями
 * @label - текстовое название поля для рендера на лендинге
 * TODO: @ref - ссылка на поле для фокуса и скролла CD-219648
 * */
export const getEnrichedErrors = (errors: FieldErrors<IFormState>, formScheme: IScheme[]) => {
  const formElements = formScheme[0].elements as IFieldElement[];

  /**
   * Обогащаем каждый объект ошибки полями из схемы
   * */
  for (const fieldWithError in errors) {
    if (errors.hasOwnProperty(fieldWithError)) {
      // @ts-ignore натяну типы в CD-219648, когда появится ref - там все сильно изменится
      (errors[fieldWithError] as unknown).label = formElements.find(el => el.name === fieldWithError).label;
    }
  }

  return errors;
};
